import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ScreenType } from 'src/app/enums/ScreenType';
import {
  IIncidents,
  IncidentStatusTimeline,
  IncidentTimelineGrpah,
} from 'src/app/models/incident';
import { IPostComments } from 'src/app/models/notice-board';
import { UserRegDetails } from 'src/app/models/user';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';

@Component({
  selector: 'app-incidents-timeline-graph-container',
  templateUrl: './incidents-timeline-graph-container.component.html',
  styleUrl: './incidents-timeline-graph-container.component.scss',
})
export class IncidentsTimelineGraphContainerComponent {
  @Input() set incidentData(val: IIncidents) {
    if (val) {
      this.isShowGraphTimeline =
        val.incidentStatusTimelineGraph == null ||
        val.incidentStatusTimelineGraph.length == 0
          ? false
          : true;

      this.incidentStatusTimelineGraph = val.incidentStatusTimelineGraph;
      this.incidentGraph = val.incidentGraph;
      this.incidentDetails = val;
      this.incidentComments = val.incidentComments;
    }
  }
  @Input() selectedCommentId: string = null;
  @Input() orgUsersData: UserRegDetails[];
  @Input() isGraph: boolean = false;
  isShowGraphTimeline = false;
  @Output() closeIncidentDetail = new EventEmitter<boolean>();
  @Output() postIncidentComment = new EventEmitter<any>();
  screenSize: ScreenType;
  incidentStatusTimelineGraph: IncidentStatusTimeline[] = [];
  incidentGraph: IncidentTimelineGrpah[] = [];
  incidentComments: IPostComments[];
  incidentDetails: IIncidents;
  constructor(private screen: AumyeResponsiveScreenService) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  onClose() {
    this.closeIncidentDetail.emit();
  }
  onPostInidentComment(val: any) {
    this.postIncidentComment.emit(val);
  }
  ScreenType = ScreenType;
}
